import React, { Component } from 'react';
import { Calendar } from '@progress/kendo-react-dateinputs';

class CustomPopup extends Component {
  render() {
    return (
      <Calendar
        {...this.props}
        bottomView="year"
        topView="decade"
        value={this.props.value}
        onChange={this.props.onChange}
        disabled={this.props.disabled}
        min={this.props.min}
        max={this.props.max}
      />
    );
  }
}

export default CustomPopup;
